import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const initialVersao = localStorage.getItem('versao') || '1'

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'img/sidebar-2.jpg',
    drawer: null,
    versao: initialVersao,
    idAviso: null,
    produtorId: null,
  },
  mutations: {
    SET_BAR_IMAGE (state, payload) {
      state.barImage = payload
    },
    SET_DRAWER (state, payload) {
      state.drawer = payload
    },
    SET_SCRIM (state, payload) {
      state.barColor = payload
    },
    VERSAO (state, payload) {
      state.versao = payload
      console.log(state.versao)
    },
  },
  actions: {
  },
})
